import { Box, Button, OsStack, Theme, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default function TermsAcceptance({
  canManage = false,
  handleTermsAccepted,
}: {
  canManage?: boolean;
  handleTermsAccepted: () => void;
}) {
  // This component is used by ClassRecordingContent.ts which is used in both learner app (RecordingPage.tsx) and website (MuxRecordingPage.tsx)
  // The learner app does not support translations, but website does
  const { t } = useTranslation(
    "ui-components-classroom\\classroom\\classRecording\\TermsAcceptance",
  );
  return (
    <Box
      sx={(theme: Theme) => ({
        width: "100%",
        maxWidth: "1024px",
        aspectRatio: "16 / 9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "primary.50",
        borderRadius: "16px",
        padding: "2rem",
        [theme.breakpoints.up("md")]: {
          padding: "6rem",
        },
      })}
    >
      <OsStack direction="column" spacing={2.5} alignItems="center">
        <Typography variant="h5" emphasized align="center">
          {t`Agreement not to share class recordings`}
        </Typography>
        <OsStack direction="column" alignItems="center">
          <Typography variant="body1" align="center">
            {t`Families’ privacy is of utmost importance.`}
          </Typography>
          <Typography variant="body1" align="center">
            {canManage
              ? t`Please confirm that you agree not to share any class recording with anyone,
except for the learners enrolled in the section and their parents.`
              : t`Please confirm that you agree not to share any class recording with anyone.`}
          </Typography>
        </OsStack>
        <Box sx={{ marginTop: 1 }}>
          <Button
            variant="contained"
            onClick={handleTermsAccepted}
            data-test-id="recording-agree-button"
            sx={{ minWidth: "224px" }}
          >{t`I Agree`}</Button>
        </Box>
      </OsStack>
    </Box>
  );
}
